import styled from "styled-components/macro";

import {useHistory, useParams} from "react-router-dom";
import {Select} from "@chakra-ui/react";
import Header from "../../components/header";
import TopBar from "../../components/top_bar";
import SortBar from "../../components/sort_bar";
import CommunityHeader from "../../components/community_header";
import Container from "../../components/container";
import Main from '../../components/main';
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import Wrapper from "../../components/wrapper";
import {useCommunityStyle, useLogs, useModeratorList} from "../../api/communities";
import {useBaseCommunity} from "../../store/hooks";
import HeaderData from "../../components/header_data";
import {useFeedback} from "../../store/feedback";
import {useModal, useRelativeTime} from "../../store";
import {useQuery} from "../../utils/router";
import NavLink from "../../components/nav_link";
import Pagination from "../../components/pagination";
import LogDetails from "../../components/log_details";
import {isPseudoCommunity} from "../../store/communites";
import CommunityInfo from "../../components/community_info";
import {themecolors} from "../../utils/themecolors";
import useWindowDimensions from "../../utils/dimensions";
import LegacySortBar from "../../components/legacy/legacy_sort_bar";

const Heading = styled.div``;
const Manage = styled.div``;
const Sort = styled.div``;
const SortOptions = styled.div``;
const Expand = styled.span``;
const Info = styled.span``;

const Ago = styled.span``;
const Moderator = styled.span``;
const Type = styled.span``;
const Target = styled.span``;
const Description = styled.span``;

const TYPE_MAPPING = {
    approvepost: 'approved a post by',
    approvecomment: 'approved a comment by',
    removepost: 'removed a post by',
    removecomment: 'removed a comment by',
    ban: 'banned',
    unban: 'unbanned',
    removenote: 'removed a note on',
    addnote: 'added a note on',
    modpost: 'distinguished a post by',
    modcomment: 'distinguished a comment by',
    stickycomment: 'stickied a comment by',
    unstickycomment: 'unstickied a comment by',
    sticky: 'stickied a post by',
    unsticky: 'unstickied a post by',
    lockpost: 'locked a post by',
    unlockpost: 'unlocked a post by',
    ignoreposts: 'ignored reports on a post by',
    unignoreposts: 'unignored reports on post by',
    ignorecomments: 'ignored reports on a comment by',
    unignorecomments: 'unignored reports on a comment by',
    sort: 'set the recommended sort on a post by',
    retrythumbs: 'requested a new preview for',
}

const LogEntry = styled(({className, log}) => {
    const ago = useRelativeTime(log.created, true);
    const modal = useModal();
    const handleExpand = () => {
        modal.open(LogDetails, {log});
    };
    return (
        <div className={className}>
            <Ago>{ago} ago</Ago>
            &nbsp;
            <Moderator><NavLink href={`/u/${log.moderator}`} react_route>{log.moderator}</NavLink></Moderator>
            &nbsp;
            <Type>{TYPE_MAPPING[log.type]}</Type>
            &nbsp;
            <Target><NavLink href={`/u/${log.target}`} react_route>{log.target}</NavLink></Target>
            {log.description &&
            <>
                &nbsp;-&nbsp;
                <Description>
                    <NavLink href={log.link} react_route>
                        {log.description}
                    </NavLink>
                </Description>
            </>
            }
        </div>
    )
})`
  padding: 6px 0;
  border-bottom: 1px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_3 : 'rgb(219, 219, 219)'};

  ${Info} {
    display: flex;
    align-items: center;
    white-space: pre;
  }

  color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};

  ${Moderator}, ${Target} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : theme.placeholder_link_2};
  }
`;

const Logs = styled(({logType, className}) => {
    const {error, feedbackCh} = useFeedback();
    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity} = useParams();
    const community = paramsCommunity || baseCommunity;
    const style = useCommunityStyle(community);

    const page = parseInt(useQuery().page || '1');
    const {type = "", moderator = ""} = useQuery();
    const logs = useLogs(feedbackCh, community, page, type, moderator, logType);
    const moderators = useModeratorList(feedbackCh, community);

    const history = useHistory();
    const handleChange = (key, value) => {
        if (key === 'type') {
            history.replace(`?moderator=${moderator}&type=${value}`);
        } else {
            history.replace(`?moderator=${value}&type=${type}`);
        }
    }

    const {width} = useWindowDimensions();

    return (
        <>
            <HeaderData title={`Moderation Logs`} community={community} community_style={style}/>
            <Header>
                {(baseCommunity !== "TheDonald" || width <= 780) &&
                <TopBar legacyConversion={baseCommunity === "TheDonald"}/>}
                {!isPseudoCommunity(community) &&
                <>
                    <CommunityHeader community={community}/>
                    {baseCommunity !== "TheDonald" &&
                    <CommunityInfo desktop community={community}/>
                    }
                </>
                }
                {baseCommunity === "TheDonald" && width > 780 && <LegacySortBar/>}
            </Header>
            <SortBar community={community}/>
            <Container className={className} forceWidth={"slim"}>
                <Wrapper>
                    {logType === 'all' &&
                    <Manage>
                        <Select size={'sx'} maxWidth={'200'} variant="unstyled" placeholder="Action Type" value={type}
                                onChange={(e) => handleChange('type', e.target.value)}>
                            {Object.entries(TYPE_MAPPING).map(([key, value]) => (
                                <option key={key} value={key}>{key}</option>
                            ))}
                        </Select>
                        <Select size={'sxs'} maxWidth={'200'} variant="unstyled" placeholder="Moderator"
                                value={moderator}
                                onChange={(e) => handleChange('moderator', e.currentTarget.value)}>
                            {moderators?.map((mod) => (
                                <option key={mod.author} value={mod.author}>{mod.author}</option>
                            ))}
                        </Select>
                    </Manage>
                    }
                    <Main>
                        {logs && logs.map((log, i) => (
                            <LogEntry key={i} log={log}/>
                        ))}
                        {error && error.toString()}
                    </Main>
                    <Pagination
                        path={`/c/${community}/${logType === 'bans' ? 'ban-logs' : 'logs'}?${type ? `type=${type}&` : ''}${moderator ? `moderator=${moderator}&` : ''}&page=`}
                        has_more page={page}/>
                </Wrapper>
                <Sidebar sidebar={style?.sidebar} community={community}/>
            </Container>
            <Footer/>
        </>
    );
})`
  ${Main} {
    padding: 20px;
    font-size: 14px;
  }

  table {
    border-collapse: collapse;
    width: 100%;
  }

  th {
    text-align: left;
    font-weight: 500;
    font-size: 16px;
  }

  td svg {
    width: 14px;
    fill: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : themecolors.light_high_impact_text};
  }

  ${Expand} {
    margin-left: 2px;
    cursor: pointer;
  }

  ${Manage} {
    display: flex;
    font-size: 14px;
    padding: 12px;
    justify-content: right;
  }

  ${Heading} {
    margin-right: 32px;
    white-space: nowrap;
    flex-grow: 1;
  }

  ${Sort} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    cursor: pointer;
    white-space: nowrap;
    margin-left: 32px;
  }

  ${Sort} svg {
    margin-left: 12px;
  }

  ${SortOptions} {
    margin-left: auto;
    display: flex;
  }

  @media only screen and (max-width: 780px) {
    ${Heading} {
      display: none;
    }

    table {
      white-space: nowrap;
    }

    ${Main} {
      overflow: scroll;
    }

    td {
      padding-right: 16px;
    }
  }
`;

export default Logs;
